<template>
  <div class="slaes-table table-component">
    <artisio-table :pagination="tableData.pagination" :sort="tableData.ordering" :items="tableData.rows"
                   :busy="tableData.loading" :fields="tableFields" show-toggle-columns
                   :search="tableData.search" :enable-simple-search="false" :extra-data="extraData"
                   @paramsChanged="getTableData" @update-toggle-columns="updateToggleColumns" :limit-variants="[5, 10]"
                   @on-column-save="updateToggleColumns" filter-toggle-string="audiences-table">

      <template v-slot:header-buttons="{selectedItems}">
        <b-button v-permission="'change_audience'" variant="primary" @click="onNewAudienceClick">
          {{$t('New Audience')}}
        </b-button>
      </template>

      <template v-slot:search-form-placeholder>
        <search-collapse table-id="audiences-table">
          <audience-search/>
        </search-collapse>
      </template>

      <template slot="cell(name)" slot-scope="{item: audience}">
        {{audience.name}}
        <action-buttons :delete-permission="'delete_audience'"
                        :view-permission="'view_audience'"
                        :edit-permission="'change_audience'"
                        @viewClick="onViewClick(audience)"
                        @editClick="onEditClick(audience)"
                        @deleteClick="onDeleteClick(audience)"/>
      </template>

      <template slot="cell(subject)" slot-scope="{item: audience}">
        {{audience.subject}}
      </template>

      <template slot="cell(total_customers)" slot-scope="{item: audience}">
        {{audience.total_customers}}
      </template>

      <template slot="cell(created_at)" slot-scope="{item: audience}">
        {{audience.created_at | toDateTime}}
      </template>

      <template slot="cell(created_by)" slot-scope="{item: audience}">
        {{audience.created_by.display_name}}
      </template>

    </artisio-table>
  </div>
</template>

<script>
  import i18nHelper from "@/core/services/i18n.service";
  import {createNamespacedHelpers} from "vuex";
  import ArtisioTable from "@/core/components/ams-table/ArtisioTable";
  import SearchCollapse from "@/core/components/search-collapse/SearchCollapse";
  import AudienceSearch from "@/modules/marketing/audience/AudienceSearch";
  import ActionButtons from "@/core/components/ams-table/ActionButtons";
  import {MARKETING_TABLE_NAME, SOURCE_AUDIENCES_LIST} from "@/modules/constants";
  import _ from 'lodash';

  const {mapState, mapActions} = createNamespacedHelpers('marketing/audience');

  export default {
    name: "AudiencesTable",
    components: {ActionButtons, AudienceSearch, SearchCollapse, ArtisioTable},
    props: {},
    data: () => {
      return {
        masterLanguage: i18nHelper.getMasterLanguage(),
      }
    },
    computed: {
      ...mapState({
        tableData: state => state.tableData,
        toggleColumns: state => state.tableData.toggleColumns,
      }),
      tableFields() {
        return _.cloneDeep(this.toggleColumns.fields).filter(f => f.isVisible)
      },
      extraData() {
        return {
          ...this.toggleColumns,
          excludeColumns: [],
          tableName: MARKETING_TABLE_NAME,
        }
      },
    },
    methods: {
      ...mapActions(['getTableData', 'showAudienceModal', 'removeAudience', 'getModalObject', 'updateToggleColumns']),
      onNewAudienceClick() {
        this.showAudienceModal({
          object: null,
          source: SOURCE_AUDIENCES_LIST
        })
      },
      onViewClick(audience) {
        this.$router.push({
          name: 'marketing.audience.view',
          params: {id: audience.uuid}
        });
      },
      onEditClick(audience) {
        this.showAudienceModal()
        this.getModalObject({uuid: audience.uuid, source: SOURCE_AUDIENCES_LIST})
      },
      async onDeleteClick(audience) {
        let success = await this.$confirm(
            this.$i18n.t(`Depending on your 3rd party marketing provider settings, deleting an audience might cause irreversible data loss. Are you sure you would like to proceed?`),
            null,
            null,
            null,
            this.$i18n.t('Please Confirm'),
            this.$i18n.t('Yes'),
            this.$i18n.t('No'),
            null,
            {
              label: this.$i18n.t("Please type 'delete' to delete this audience"),
              text: 'delete'
            }
        )
        if (!success) {
          return;
        }
        let res = await this.removeAudience(audience);
        if (res.success) {
          this.$toast('success', this.$i18n.t('Audience was successfully deleted'));
        }
      }
    },
    mounted() {
      this.getTableData();
    },
  }
</script>

<style lang="scss" scoped>
</style>

